import { AppUserWindows, SignInRequest } from '../../types/core/auth.types';
import { api } from './api';

export const getAuthorize = () => api.get<boolean>('/User/Authorize').then((res) => res.data);

export const getCurrentUser = () =>
  api.get<AppUserWindows>('/User/GetCurrentUser').then((res) => res.data);

export const getUserSearch = (name: string) =>
  api.get<AppUserWindows[]>(`/User/SearchByName?name=${name}`).then((res) => res.data);

export const getUserByNetId = (netId: string) =>
  api.get<AppUserWindows>(`/User/SearchByNetId?netId=${netId}`).then((res) => res.data);

export const getIsAuthenticated = () =>
  api.get<boolean>('/User/IsAuthenticated').then((res) => res.data);

export const signIn = (data: SignInRequest) =>
  api.post(`/User/LogIn?username=${data.id}&password=${data.password}`).then((res) => res.data);

export const signOut = () => api.get<AppUserWindows>('/User/LogOut').then((res) => res.data);
